export var rootpath = '/app';
export var pathToPageEditorFrontPage = function (noteId) { return rootpath + "/note/notes/" + noteId + "/pages/front-page"; };
export var pathToPageEditor = function (noteId, pageId) {
    return [rootpath, 'note', 'notes', noteId, 'pages', pageId].join('/');
};
export var pathToPmlEditPage = function (kind, fileId) {
    return [rootpath, kind.toLocaleLowerCase(), 'projects', fileId].join('/');
};
export var pathToWorkPreview = function (workId) { return [rootpath, 'drill', 'work', 'works', workId, 'preview'].join('/'); };
export var pathToWorkTemplatePreview = function (courseId, workTemplateGroupId, workTemplateId) {
    return [rootpath, 'drill', 'work', 'templates', courseId, workTemplateGroupId, workTemplateId, 'preview'].join('/');
};
export var pathToWorkList = function () { return [rootpath, 'drill', 'work', 'works'].join('/'); };
export default {
    pathToPageEditorFrontPage: pathToPageEditorFrontPage,
};
